/**
 * Catalogue glyphs shared by every surface that lists a workflow, prompt, skill
 * or connector.
 *
 * Each constant is the glyph for every row of that kind, whatever the catalogue
 * record's own `icon` field says. A skill, a workflow and a connector each
 * carry an author-chosen or vendor icon, and the listing surfaces deliberately
 * ignore all three: the glyph beside a row is what tells a reader which kind the
 * row belongs to, which stops working the moment two rows of one kind differ.
 * The Library reached this conclusion first, for all four of its kinds, and the
 * chat `/` command menu and `@` mention list now read the same constants, so a
 * given kind looks the same wherever it is listed.
 *
 * ⚠️ These live here rather than beside any one surface because the surfaces
 * disagreed for as long as they each held their own literal. `SKILL_ICON` was
 * extracted first and stayed consistent; the other three were left as inline
 * strings and `prompt` promptly diverged, with the Library on
 * `solar:notes-linear` while both chat surfaces used `solar:document-text-linear`.
 * A new listing surface should import from here rather than copy a string.
 *
 * The per-item icon still has a job. `SkillsSettings` renders a skill's own
 * icon, which is where an author sees the one they picked, and the Connectors
 * settings page shows each service's real logo.
 *
 * ⚠️ The consuming types (`SkillCommandEntry`, `MentionSkill`, `SkillListItem`,
 * `LibraryItem`) deliberately have no `icon` field, so a mapper cannot
 * reintroduce pass-through without a type error.
 */
export const WORKFLOW_ICON = "solar:widget-2-linear";
export const PROMPT_ICON = "solar:document-text-linear";
export const SKILL_ICON = "solar:magic-stick-3-linear";
export const CONNECTOR_ICON = "solar:plug-circle-linear";
